// extracted by mini-css-extract-plugin
export default {"archive":"ArchiveJobModal_archive__c1N6j","cancel":"ArchiveJobModal_cancel__ZFB5O"};